import { Button } from '@makemydeal/dr-ui-bricks-components';

import PageHeader from '../PageHeader/PageHeader';
import { ShowroomCardContainer } from '../Showroom/showroom.style';
import { TRADE_IN_OVERVIEW_CONTENT, TRADE_IN_OVERVIEW_TEST_ID } from '../../constants';
import { RemoveTradeInModal } from './RemoveTradeInModal';
import { TradeInOverviewInfo } from './TradeInOverviewInfo';
import { TradeInOverviewAction, TradeInOverviewRoot } from './TradeInOverview.style';
import { useTradeInOverview } from '../../hooks/useTradeInOverview';

export const TradeInOverview = () => {
    const { tradeIn, showRemoveTradeInConfirm, onStart, onEdit, onRemove, onCancelRemove, onConfirmRemove } = useTradeInOverview();

    return (
        <ShowroomCardContainer>
            <TradeInOverviewRoot data-testid={TRADE_IN_OVERVIEW_TEST_ID} $hasRecord={!!tradeIn?.data}>
                <PageHeader
                    isResponsive
                    heading={TRADE_IN_OVERVIEW_CONTENT.heading}
                    description={TRADE_IN_OVERVIEW_CONTENT.description}
                />
                {tradeIn?.data ? (
                    <>
                        <TradeInOverviewInfo tradeIn={tradeIn} onEdit={onEdit} onRemove={onRemove} />
                        {showRemoveTradeInConfirm && (
                            <RemoveTradeInModal
                                vehicleName={tradeIn.data.vehicleName ?? ''}
                                onCancel={onCancelRemove}
                                onConfirm={onConfirmRemove}
                            />
                        )}
                    </>
                ) : (
                    <TradeInOverviewAction>
                        <Button
                            buttonStyle="primary"
                            onClick={onStart}
                            buttonSize="small"
                            data-testid={`${TRADE_IN_OVERVIEW_TEST_ID}-action`}
                        >
                            {TRADE_IN_OVERVIEW_CONTENT.startLabel}
                        </Button>
                    </TradeInOverviewAction>
                )}
            </TradeInOverviewRoot>
        </ShowroomCardContainer>
    );
};
